/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
// import Register from 'views/Register.js';
import Login from "views/Login.js";
import Brands from "views/brands/Brands";
import CodeRequests from "views/CodeRequests/CodeRequests";
import UserLogs from "views/userLogs/UserLogs";
// import BrandCodes from 'views/BrandCodes/BrandCodes';
// import Customization from "views/Customization/Customization";
import AdminBrandCodes from "views/AdminBrandCodes/AdminBrandCodes";
import BrandDashboard from "views/BrandDashboard/BrandDashboard";
import ResetPassword from "views/ResetPassword";
import BrandCodesRequests from "views/BrandCodesRequests/BrandCodesRequests";
import VerifyOtp from "views/VerifyOtp";
import VectorMap from "views/Map/VectorMap";
import MapBox from "views/Map/MapBox";
import OrderNotifications from "views/Settings/OrderNotifications";
import Webhooks from "views/Settings/Webhooks";
import TeamMembers from "views/Settings/TeamMembers";
import SettingsHub from "views/Settings/SettingsHub";
import TeamAccept from "views/Auth/TeamAccept";
import { ReactComponent as SettingsIcon } from "./assets/customization.svg";
import Orders from "views/Orders/Orders";
import BrandOrders from "views/BrandOrder/Orders";
import { ReactComponent as Dashboard } from "./assets/dashboard.svg"
import { ReactComponent as Order } from "./assets/orders.svg"
import { ReactComponent as Brand } from "./assets/brand.svg"
import { ReactComponent as Map } from "./assets/Map.svg"
import { ReactComponent as Server } from "./assets/serverLogs.svg"
import { ReactComponent as User } from "./assets/userLogs.svg"
// import { ReactComponent as Customize } from "./assets/customization.svg"
import { ReactComponent as Reward } from "./assets/reward.svg"
import RewardCenter from "views/BrandReward/RewardCenter";

var routes = [
  /*    Super Admin Routes    */
  {
    path: "/:id/code",
    name: "Brand Codes",
    icon: "ni ni-single-02 text-primary",
    component: AdminBrandCodes,
    layout: "/admin",
    isChild: true,
  },
  {
    path: "/index",
    name: "Dashboard",
    icon: Dashboard,
    component: Index,
    layout: "/admin",
    isChild: false,
  },
  {
    path: "/orders",
    name: "Orders",
    icon: Order,
    component: Orders,
    layout: "/admin",
    isChild: false,
  },
  {
    path: "/brands",
    name: "Brands Management",
    icon: Brand,
    component: Brands,
    layout: "/admin",
    isChild: false,
  },
  {
    path: "/map",
    name: "Activity Map",
    icon: Map,
    component: MapBox,
    layout: "/admin",
    isChild: false,
  },

  // {
  //   path: "/batch-requests",
  //   name: "Batch Requests",
  //   // icon: "fas fa-plus-square text-primary",
  //   component: CodeRequests,
  //   layout: "/admin",
  //   isChild: false,
  // },
  {
    path: "/userlogs",
    name: "User Logs ",
    icon: User,
    component: UserLogs,
    layout: "/admin",
    isChild: false,
  },
  /*    Brand Admin Routes    */
  {
    path: "/index",
    name: "Dashboard",
    icon: Dashboard,
    component: BrandDashboard,
    layout: "/brand",
    isChild: false,
  },
  {
    path: "/orders",
    name: "Orders",
    icon: Order,
    component: BrandOrders,
    layout: "/brand",
    isChild: false,
  },
  // {
  //   path: "/batch-requests",
  //   name: "Batch Requests",
  //   // icon: "fas fa-plus-square text-primary",
  //   component: BrandCodesRequests,
  //   layout: "/brand",
  //   isChild: false,
  // },
  {
    path: "/map",
    name: "Activity Map",
    icon: Map,
    component: MapBox,
    layout: "/brand",
    isChild: false,
  },
  {
    path: "/rewardCenter",
    name: "Reward Center",
    icon: Reward,
    component: RewardCenter,
    layout: "/brand",
    isChild: false,
  },
  {
    path: "/user-logs",
    name: "Logs",
    icon: User,
    component: UserLogs,
    layout: "/brand",
    isChild: false,
  },
  // Settings hub — single sidebar entry housing General, Order Notifications,
  // Integrations, Team Members, and Webhooks. Each sub-section is selected
  // via URL hash (`/brand/settings#webhooks`, etc).
  {
    path: "/settings",
    name: "Settings",
    icon: SettingsIcon,
    component: SettingsHub,
    layout: "/brand",
    isChild: false,
  },
  {
    path: "/settings",
    name: "Settings",
    icon: SettingsIcon,
    component: SettingsHub,
    layout: "/admin",
    isChild: false,
  },
  // Legacy routes kept invisible so existing deep links / bookmarks resolve.
  // New navigation goes through SettingsHub above. If no external system
  // depends on these paths, they can be removed in a follow-up.
  {
    path: "/order-notifications",
    name: "Order Notifications",
    icon: Order,
    component: OrderNotifications,
    layout: "/brand",
    invisible: true,
    isChild: false,
  },
  {
    path: "/webhooks",
    name: "Webhooks",
    icon: Server,
    component: Webhooks,
    layout: "/admin",
    invisible: true,
    isChild: false,
  },
  {
    path: "/webhooks",
    name: "Webhooks",
    icon: Server,
    component: Webhooks,
    layout: "/brand",
    invisible: true,
    isChild: false,
  },
  {
    path: "/team",
    name: "Team",
    icon: User,
    component: TeamMembers,
    layout: "/brand",
    invisible: true,
    isChild: false,
  },
  //  {
  //   path: '/codes',
  //   name: 'All Codes',
  //   icon: 'fas fa-barcode text-primary',
  //   component: BrandCodes,
  //   layout: '/brand',
  //   isChild: false,
  // },
  // {
  //   path: "/customization",
  //   name: "Customization",
  //   icon: Customize,
  //   component: Customization,
  //   layout: "/brand",
  //   isChild: false,
  // },

  // {
  //   path: "/settings",
  //   name: "Settings",
  //   // icon: "fas fa-cog text-primary",
  //   component: Settings,
  //   layout: "/brand",
  //   isChild: false,
  // },
  // {
  //   path: '/batch',
  //   name: 'View Brand',
  //   outerLink: true,
  //   icon: 'fas fa-barcode text-primary',
  //   component: BrandCodes,
  //   layout: '/brand',
  //   isChild: false,
  // },
  /*    Auth Routes   */
  // {
  //   path: '/register',
  //   name: 'Register',
  //   icon: 'ni ni-key-25 text-info',
  //   component: Register,
  //   layout: '/auth',
  //   isChild: false
  // },
  {
    path: "/login",
    name: "Login",
    // icon: "ni ni-circle-08 text-pink",
    component: Login,
    layout: "/auth",
    isChild: false,
  },
  {
    path: "/verify-otp/:email",
    name: "Verify Otp",
    // icon: "ni ni-circle-08 text-pink",
    component: VerifyOtp,
    layout: "/auth",
    isChild: false,
  },
  {
    path: "/team-accept",
    name: "Accept Team Invite",
    component: TeamAccept,
    layout: "/auth",
    isChild: false,
  },
  {
    path: "/verify/:token",
    name: "Dashboard",
    // icon: "ni ni-tv-2 text-red",
    component: ResetPassword,
    layout: "/reset",
    isChild: false,
  },
];
export default routes;
